import { Play, Brain, Calculator, Star, Sparkles, Trophy, Rocket, Lightbulb, Puzzle, BookOpen, Target, Zap } from "lucide-react";

export const QUIZ_ICONS = {
  play: Play,
  brain: Brain,
  calculator: Calculator,
  star: Star,
  sparkles: Sparkles,
  trophy: Trophy,
  rocket: Rocket,
  lightbulb: Lightbulb,
  puzzle: Puzzle,
  book: BookOpen,
  target: Target,
  zap: Zap,
};

export const QUIZ_ICON_OPTIONS = Object.keys(QUIZ_ICONS);

// Distinct color palette cycled per card when no explicit color is set.
export const QUIZ_ICON_PALETTE = [
  "#FF6B6B", "#005F73", "#2D9C5A", "#FFB703",
  "#7B2CBF", "#E63946", "#1B5E3A", "#0096C7",
  "#F4A261", "#9D4EDD",
];

// Darken a hex color for the drop-shadow.
export function darkenHex(hex, amount = 40) {
  const h = (hex || "#FF6B6B").replace("#", "");
  if (h.length !== 6) return "#C92A2A";
  const n = parseInt(h, 16);
  const r = Math.max(0, (n >> 16) - amount);
  const g = Math.max(0, ((n >> 8) & 0xff) - amount);
  const b = Math.max(0, (n & 0xff) - amount);
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, "0")}`;
}

export function quizIconColor(quiz, index) {
  return quiz?.icon_color || QUIZ_ICON_PALETTE[index % QUIZ_ICON_PALETTE.length];
}

export function quizIconComponent(quiz) {
  return QUIZ_ICONS[quiz?.icon] || QUIZ_ICONS.play;
}
